module.exports = __webpack_public_path__ + "static/media/client-logo-vertical-n.1e0a59ee.svg";